// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// THIS FILE WAS AUTOGENERATED
var ContextTagKeys = /** @class */ (function () {
    function ContextTagKeys() {
        this.applicationVersion = "ai.application.ver";
        this.applicationBuild = "ai.application.build";
        this.applicationTypeId = "ai.application.typeId";
        this.applicationId = "ai.application.applicationId";
        this.applicationLayer = "ai.application.layer";
        this.deviceId = "ai.device.id";
        this.deviceIp = "ai.device.ip";
        this.deviceLanguage = "ai.device.language";
        this.deviceLocale = "ai.device.locale";
        this.deviceModel = "ai.device.model";
        this.deviceFriendlyName = "ai.device.friendlyName";
        this.deviceNetwork = "ai.device.network";
        this.deviceNetworkName = "ai.device.networkName";
        this.deviceOEMName = "ai.device.oemName";
        this.deviceOS = "ai.device.os";
        this.deviceOSVersion = "ai.device.osVersion";
        this.deviceRoleInstance = "ai.device.roleInstance";
        this.deviceRoleName = "ai.device.roleName";
        this.deviceScreenResolution = "ai.device.screenResolution";
        this.deviceType = "ai.device.type";
        this.deviceMachineName = "ai.device.machineName";
        this.deviceVMName = "ai.device.vmName";
        this.deviceBrowser = "ai.device.browser";
        this.deviceBrowserVersion = "ai.device.browserVersion";
        this.locationIp = "ai.location.ip";
        this.locationCountry = "ai.location.country";
        this.locationProvince = "ai.location.province";
        this.locationCity = "ai.location.city";
        this.operationId = "ai.operation.id";
        this.operationName = "ai.operation.name";
        this.operationParentId = "ai.operation.parentId";
        this.operationRootId = "ai.operation.rootId";
        this.operationSyntheticSource = "ai.operation.syntheticSource";
        this.operationCorrelationVector = "ai.operation.correlationVector";
        this.sessionId = "ai.session.id";
        this.sessionIsFirst = "ai.session.isFirst";
        this.sessionIsNew = "ai.session.isNew";
        this.userAccountAcquisitionDate = "ai.user.accountAcquisitionDate";
        this.userAccountId = "ai.user.accountId";
        this.userAgent = "ai.user.userAgent";
        this.userId = "ai.user.id";
        this.userStoreRegion = "ai.user.storeRegion";
        this.userAuthUserId = "ai.user.authUserId";
        this.userAnonymousUserAcquisitionDate = "ai.user.anonUserAcquisitionDate";
        this.userAuthenticatedUserAcquisitionDate = "ai.user.authUserAcquisitionDate";
        this.cloudName = "ai.cloud.name";
        this.cloudRole = "ai.cloud.role";
        this.cloudRoleVer = "ai.cloud.roleVer";
        this.cloudRoleInstance = "ai.cloud.roleInstance";
        this.cloudEnvironment = "ai.cloud.environment";
        this.cloudLocation = "ai.cloud.location";
        this.cloudDeploymentUnit = "ai.cloud.deploymentUnit";
        this.internalNodeName = "ai.internal.nodeName";
        this.internalSdkVersion = "ai.internal.sdkVersion";
        this.internalAgentVersion = "ai.internal.agentVersion";
        this.internalSnippet = "ai.internal.snippet";
        this.internalSdkSrc = "ai.internal.sdkSrc";
    }
    return ContextTagKeys;
}());
export { ContextTagKeys };
//# sourceMappingURL=ContextTagKeys.js.map